__turbopack_context__.v({
  "container": "_6u7pfq_container",
  "selectContainer": "_6u7pfq_selectContainer",
});
